"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaletteRegistry = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _eventer = require("@blockwell/eventer");
var _reactivity = require("@vue/reactivity");
let paletteIdCounter = 1;
class PaletteRegistry {
  constructor(blocks, variableTypes, abis, batches, nft, tracker, convertTypes) {
    (0, _defineProperty2.default)(this, "events", new _eventer.Eventer());
    (0, _defineProperty2.default)(this, "id", paletteIdCounter++);
    (0, _defineProperty2.default)(this, "parameters", (0, _reactivity.reactive)({}));
    (0, _defineProperty2.default)(this, "editor", false);
    this.blocks = blocks;
    this.variableTypes = variableTypes;
    this.abis = abis;
    this.batches = batches;
    this.nft = nft;
    this.tracker = tracker;
    this.convertTypes = convertTypes;
  }
  change(change) {
    this.events.emit("change", {
      ...change,
      paletteId: this.id
    });
  }
  interact(interaction) {
    this.events.emit("interaction", interaction);
  }
  updateParameters(update) {
    let keys = Object.keys(this.parameters);
    for (let [key, val] of Object.entries(update)) {
      keys = keys.filter(it => it !== key);
      this.parameters[key] = val;
    }
    for (let key of keys) {
      delete this.parameters[key];
    }
  }
}
exports.PaletteRegistry = PaletteRegistry;
//# sourceMappingURL=PaletteRegistry.js.map